export default __webpack_public_path__ + "static/media/RejectedIcon.c8713e95.svg";